<template>
  <span>
    <span v-if="hasVersions"  @click="showHistory = !showHistory"
        class="pull-right history">
      Alterado {{hasVersions}} vez<span v-if="hasVersions > 1">es</span>.

    </span>
    <div v-for="version in versions">
      <span v-if="version.type == 'text' || version.type == 'textarea' || version.type == 'cpf' || version.type == 'cnpj' || version.type == 'phone'">
        {{version.stringField}}
      </span>
      <span v-if="version.type == 'computed'">
        {{compute(version.stringField, fields.filter(f => !f.newerVersion && isSameSection(f, sectionOrder + 1, sectionId)))}} <span class="pull-right" style="color: gray"><span class="glyphicon glyphicon-info-sign" :title="version.stringField"></span> <span style="font-size: 10px">Computado automaticamente</span></span>
      </span>
      <span v-if="version.type == 'date' && version.dateField">
        <span class="glyphicon glyphicon-calendar"></span> {{new Date(version.dateField.iso).toLocaleString('pt-BR')}}
      </span>
      <span v-if="version.type == 'number'">
        {{version.numField}}
      </span>
      <span v-if="version.type == 'money'">
        {{version.numField}}
      </span>
      <span v-if="version.type == 'checkbox'">
        <ul class="list-inline">
          <li v-for="option in version.checkboxField">
          <span class="glyphicon glyphicon-ok"></span>
          {{option.name}}</li>
        </ul>
      </span>
      <a :href="version.stringField" v-if="version.type == 'link'" target="_blank">
        <span class="glyphicon glyphicon-new-window" v-if="version.stringField"></span>
        {{version.stringField}}
      </a>
      
      <span v-if="version.type == 'file'">
        <span class="text-muted" v-if="!version.fileField">Nenhum arquivo anexado.</span>
        <div v-else>
          <span class="glyphicon glyphicon-paperclip"></span> <a :href="version.fileField.url" target="_blank">Visualizar</a>
        </div>
      </span>

      <span v-if="version.type == 'document'">
        <span class="text-muted" v-if="!version.fileField">Nenhum arquivo anexado.</span>
        <div v-else>
          <span class="glyphicon glyphicon-paperclip"></span> <a :href="version.fileField.url" target="_blank">Visualizar</a>
        </div>
      </span>
      <span v-if="version.type === 'select' && version.selectField">
        {{version.selectField.name}}
      </span>
      <span v-if="showHistory">por <span class="version-owner">{{version.owner.username}}</span> <span class="version-date">{{formatDate(version.createdAt)}}</span></span>
    </div>
  </span>
</template>

<script>
import { computeValue } from '../../Global'
import moment from 'moment'
moment.locale('pt-br')

export default {
  props: ['field', 'fields', 'sectionOrder', 'sectionId'],
  data () {
    return {
      showHistory: false
    }
  },
  methods: {
    isSameSection (f, order, sectionIdWithOrder) {
      return !f.section || order + '-' + f.section.objectId === sectionIdWithOrder
    },
    compute (formula, fields) {
      return computeValue(formula, fields)
    },
    getVersions () {
      let versions = this.fields && this.fields
        .filter(f => f.newerVersion &&
          (
            (this.field.original && f.objectId === this.field.original.objectId) ||
            (f.original && this.field.original && f.original.objectId === this.field.original.objectId))
          )
      if (versions) {
        versions.sort((v1, v2) => v1.createdAt < v2.createdAt)
      }
      return versions
    },
    formatDate (date) {
      return moment(new Date(date)).fromNow()
    }
  },
  computed: {
    hasVersions () {
      let versions = this.getVersions()
      return versions && versions.length
    },
    newerField () {
      return this.field
    },
    versions () {
      if (this.showHistory) {
        return [this.field].concat(this.getVersions())
      } else {
        return [this.newerField]
      }
    }
  }
}
</script>

<style scoped>
.history {
  cursor: pointer;
  color: gray;
  font-size: 10px;
}

.version-date{
  color: gray;
  font-size: 10px;
}

.version-owner {
  color: #606060;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// DynamicViewField.vue?41a1bffd